import { Link } from "react-router-dom";
import type { ReactNode } from "react";
import { headingText } from "@/lib/heading";

type Props = {
  eyebrow?: string;
  title: string;
  children?: ReactNode;
  to?: string;
  href?: string;
  badge?: string;
};

export function SignalCard({
  eyebrow,
  title,
  children,
  to,
  href,
  badge,
}: Props) {
  const heading = <h3>{headingText(title)}</h3>;
  return (
    <article className="signal-card">
      <div className="cluster" style={{ marginBottom: "0.5rem" }}>
        {eyebrow ? <p className="eyebrow">{eyebrow}</p> : null}
        {badge ? <span className="badge">{badge}</span> : null}
      </div>
      {to ? <Link to={to}>{heading}</Link> : href ? <a href={href}>{heading}</a> : heading}
      <div>{children}</div>
    </article>
  );
}
